export const idlFactory = ({ IDL }) => {
  const Token = IDL.Record({ address: IDL.Text, standard: IDL.Text })
  const CreatePoolArgs = IDL.Record({
    fee: IDL.Nat,
    sqrtPriceX96: IDL.Text,
    token0: Token,
    token1: Token,
  })
  const PoolData = IDL.Record({
    fee: IDL.Nat,
    key: IDL.Text,
    tickSpacing: IDL.Int,
    token0: Token,
    token1: Token,
    canisterId: IDL.Principal,
  })
  const Error = IDL.Variant({
    CommonError: IDL.Null,
    InternalError: IDL.Text,
    UnsupportedToken: IDL.Text,
    InsufficientFunds: IDL.Null,
  })
  const Result_3 = IDL.Variant({ ok: PoolData, err: Error })
  const CycleInfo = IDL.Record({ balance: IDL.Nat, available: IDL.Nat })
  const Result_5 = IDL.Variant({ ok: CycleInfo, err: Error })
  const Page = IDL.Record({
    content: IDL.Vec(PoolData),
    offset: IDL.Nat,
    limit: IDL.Nat,
    totalElements: IDL.Nat,
  })
  const Result_4 = IDL.Variant({ ok: Page, err: Error })
  const GetPoolArgs = IDL.Record({
    fee: IDL.Nat,
    token0: Token,
    token1: Token,
  })
  const Result_2 = IDL.Variant({ ok: IDL.Vec(PoolData), err: Error })
  const Result_1 = IDL.Variant({ ok: IDL.Null, err: Error })
  const Result = IDL.Variant({ ok: IDL.Text, err: Error })
  return IDL.Service({
    addPoolControllers: IDL.Func([IDL.Principal, IDL.Vec(IDL.Principal)], [], []),
    clearRemovedPool: IDL.Func([IDL.Principal], [IDL.Text], []),
    createPool: IDL.Func([CreatePoolArgs], [Result_3], []),
    getCycleInfo: IDL.Func([], [Result_5], []),
    getPagedPools: IDL.Func([IDL.Nat, IDL.Nat], [Result_4], ['query']),
    getPool: IDL.Func([GetPoolArgs], [Result_3], ['query']),
    getPools: IDL.Func([], [Result_2], ['query']),
    getRemovedPools: IDL.Func([], [Result_2], ['query']),
    getVersion: IDL.Func([], [IDL.Text], ['query']),
    removePool: IDL.Func([GetPoolArgs], [IDL.Text], []),
    removePoolControllers: IDL.Func([IDL.Principal, IDL.Vec(IDL.Principal)], [], []),
    removePoolWithdrawErrorLog: IDL.Func([IDL.Principal, IDL.Nat, IDL.Bool], [Result_1], []),
    restorePool: IDL.Func([IDL.Principal], [IDL.Text], []),
    setPoolAdmins: IDL.Func([IDL.Principal, IDL.Vec(IDL.Principal)], [], []),
    upgradePoolTokenStandard: IDL.Func([IDL.Principal, IDL.Principal], [Result], []),
    validateAddPoolControllers: IDL.Func([IDL.Principal, IDL.Vec(IDL.Principal)], [IDL.Bool], []),
    validateClearRemovedPool: IDL.Func([IDL.Principal], [IDL.Bool], []),
    validateRemovePool: IDL.Func([GetPoolArgs], [IDL.Bool], []),
    validateRemovePoolControllers: IDL.Func(
      [IDL.Principal, IDL.Vec(IDL.Principal)],
      [IDL.Bool],
      []
    ),
    validateRemovePoolWithdrawErrorLog: IDL.Func(
      [IDL.Principal, IDL.Nat, IDL.Bool],
      [IDL.Bool],
      []
    ),
    validateRestorePool: IDL.Func([IDL.Principal], [IDL.Bool], []),
    validateSetPoolAdmins: IDL.Func([IDL.Principal, IDL.Vec(IDL.Principal)], [IDL.Bool], []),
    validateUpgradePoolTokenStandard: IDL.Func([IDL.Principal, IDL.Principal], [IDL.Bool], []),
  })
}
export const init = ({ IDL }) => {
  return []
}
